import classnames from 'classnames'

import type { PortableTextComponentProps } from '~/components/atoms/BlockContent/BlockContent'
import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import { ComponentTheme } from '~/components/themes'

import Fixture from '../Fixture/Fixture'
import { TextSizes } from '../Text/Text'

import styles from './LeadParagraph.module.css'

export interface LeadParagraphProps {
  _key: string
  body: PortableTextComponentProps['blocks']
  theme?: ComponentTheme
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  testID?: string
}

export default function LeadParagraph({
  _key,
  body,
  theme = ComponentTheme.primary,
  verticalPadding,
  noPaddingBottom,
  testID,
}: LeadParagraphProps) {
  const strippedBody = Object.values(body ?? {}).filter((block: any) => {
    if (block?._type !== 'block' || !Array.isArray(block.children)) {
      return true
    }

    return block.children.some(
      (child: any) =>
        typeof child?.text === 'string' && child.text.trim() !== ''
    )
  }) as LeadParagraphProps['body']
  return (
    <Fixture
      theme={theme}
      verticalPadding={verticalPadding}
      noPaddingTop={true}
    >
      <div className={styles.base} data-testid={testID} id={_key}>
        <div
          className={classnames(
            styles.bodyText,
            styles[TextSizes.magPrimaryTitleSml],
            'prose',
            'json-ld-speakable'
          )}
        >
          <BlockContent value={strippedBody}></BlockContent>
        </div>
      </div>
    </Fixture>
  )
}
